import { render, staticRenderFns } from "./TabAccountSetting.vue?vue&type=template&id=56efd309&scoped=true&"
import script from "./TabAccountSetting.vue?vue&type=script&lang=js&"
export * from "./TabAccountSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56efd309",
  null
  
)

export default component.exports